import React, { Component } from "react";
import Data from "../../config/data";
import ScrollView from "./ScrollView";
import Content from "./Content";

export default class UserServiceAgreement extends Component {

    render() {
        const data = Data.userServiceAgreement;
        return (
            <ScrollView>
                <Content data={data} />
            </ScrollView>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/newEra/userServiceAgreement.js